<template>
  <!-- content(s) -->
  <div>
    <section class="hr full mg0">
      <ul class="cateBtn">
        <li>
          <div class="block">
            <span class="titH4">카테고리</span>
          </div>
          <div class="detail">
            <div class="btnGroup">
              <button type="button" :class="mainMenuIndex == 0 ? 'btn_l s' : 'btn_s s'" id="btn_sAll" @click="selectCategory('0')">
                전체
              </button>
              <button
                v-if="category.categoryYN == 'Y'"
                type="button"
                :class="mainMenuIndex == category.menuIndex ? 'btn_l s' : 'btn_s s'"
                :id="'btn_s' + cateIndex"
                @click="selectCategory(category.menuIndex)"
                v-for="(category, cateIndex) in categoryList"
                :key="cateIndex"
                v-text="category.menuName"
              ></button>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <section class="full hr mg0">
      <a v-for="(banner, bannerIndex) in bannerList" :key="bannerIndex" v-if="bannerIndex == '0'" class="img">
        <span @click="$router.push(banner.bannerUrl)">
          <img :src="banner.imgURL" :alt="banner.bannerName" />
        </span>
      </a>
    </section>
    <template v-for="(slideList, slideListIndex) in slideList">
      <section class="hr rcDetail" v-show="mainMenuIndex == slideList.menuIndex" v-if="slideList.productList.length > 0">
        <div class="titArea">
          <h2 class="titH3">웰몰 추천 초특가</h2>
        </div>

        <div class="slide goodsList special large" :id="'slide' + slideList.menuIndex">
          <ul class="slideList">
            <li v-for="(slide, slideIndex) in slideList.productList" :key="slideIndex" v-if="slideIndex < 6" class="swiper-slide">
              <a class="block" @click="goProductDetail(slide.productIndex, slide.discntFlag)">
                <div class="img imgCover">
                  <div class="badgeArea">
                    <span class="badge" v-for="(topTags, topTagsIndex) in slide.tagInfos.topTags" :key="topTagsIndex">
                      <img :src="topTags.imgPath" />
                    </span>
                  </div>
                  <img :src="slide.thumbnailOriginal" :alt="slide.displayName" />
                </div>
                <p class="tit row2" v-text="slide.productName"></p>
                <p class="desc" v-text="slide.model"></p>
                <div class="hashtag">
                  <span v-for="(bottomTags, bottomTagsIndex) in slide.tagInfos.bottomTags" :key="bottomTagsIndex" v-text="bottomTags.tagName"></span>
                </div>
              </a>
              <div class="price">
                <span class="money del">
                  월
                  <span v-text="getConvertPrice(slide.rentalAmount)"></span>
                  원
                </span>
                <br />
                <span class="money pointC1">
                  월
                  <em v-text="getConvertPrice(slide.cardDCrentalAmount)"></em>
                  원
                  <i>/제휴카드가</i>
                </span>
              </div>
              <div class="utilBtn">
                <a href="javascript:;" @click="updateWishList(slide)" class="icoBtn zzim" :class="{ on: slide.wishItem }">
                  <span>
                    찜 (
                    <i v-text="getConvertPrice(slide.wishCount)"></i>
                    )
                  </span>
                </a>
              </div>
            </li>
          </ul>
          <!-- <div class="swiper-scrollbar"></div> -->
        </div>
      </section>
    </template>
    <section class="full hr mg0">
      <a v-for="(banner, bannerIndex) in bannerList" :key="bannerIndex" v-if="bannerIndex == '1'">
        <span class="img" @click="$router.push(banner.bannerUrl)">
          <img :src="banner.imgURL" :alt="banner.bannerName" />
        </span>
      </a>
    </section>

    <section class="full hr">
      <!-- TODO 기획서에는 아래로 스크롤시 상단에 고정되도록 되어있으나 퍼블리싱은 되어 있지 않음 -->
      <div class="sortArea filter">
        <div class="lcont">
          <span class="txt">
            총
            <em v-text="getConvertPrice(productListLength)"></em>
            개
          </span>
        </div>
        <div class="rcont">
          <select class="btnTxt_sort" title="상품분류 선택" v-model="mainMenuIndex" @change="selectCategory(mainMenuIndex)">
            <option value="0" selected="selected">전체</option>

            <option :value="category.menuIndex" v-for="(category, cateIndex) in categoryList" :key="cateIndex" v-if="category.categoryYN == 'Y'">
              {{ category.menuName }}
            </option>
          </select>
          <select class="btnTxt_sort" title="상품정렬 선택" @change="sort($event.target.value)">
            <option value="popular" selected="selected">인기순</option>
            <option value="new">신상품순</option>
            <option value="highPrice">최고가순</option>
            <option value="lowPrice">최저가순</option>
          </select>
        </div>
      </div>

      <ul class="prdList">
        <li v-for="(product, productIndex) in productList" :key="productIndex">
          <div class="block">
            <div class="prdItem">
              <div class="imgArea">
                <div class="badgeArea">
                  <span class="badge" v-for="(topTags, topTagsIndex) in product.tagInfos.topTags" :key="topTagsIndex">
                    <img :src="topTags.imgPath" />
                  </span>
                </div>
                <a class="img imgCover" @click="goProductDetail(product.productIndex, product.discntFlag)">
                  <img :src="product.thumbnail" :alt="product.displayName" />
                </a>
              </div>
              <div class="infoArea">
                <a class="tit row2" @click="goProductDetail(product.productIndex, product.discntFlag)">
                  <span v-text="product.productName"></span>
                </a>
                <div class="txtItem">
                  <span v-text="product.model"></span>
                </div>
                <div class="hashtag">
                  <span
                    v-for="(bottomTags, bottomTagsIndex) in product.tagInfos.bottomTags"
                    :key="bottomTagsIndex"
                    v-text="bottomTags.tagName"
                  ></span>
                </div>
                <div class="price">
                  <span class="money del">
                    월
                    <span v-text="getConvertPrice(product.rentalAmount)"></span>
                    원
                  </span>
                  <br />
                  <span class="money pointC1">
                    월
                    <em v-text="getConvertPrice(product.cardDCrentalAmount)"></em>
                    원
                    <i>/제휴카드가</i>
                  </span>
                </div>

                <ul class="utilBtn">
                  <li>
                    <a href="javascript:;" @click="updateWishList(product)" class="icoBtn zzim" :class="{ on: product.wishItem }">
                      <span>
                        찜 (
                        <i v-text="getConvertPrice(product.wishCount)"></i>
                        )
                      </span>
                    </a>
                    <!-- 클래스 on -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>

    <ConfirmPop v-if="confirmPop" @confirm="confirm" @cancel="cancel" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
    <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
    <infinite-loading spinner="circles" @infinite="infiniteHandler" v-show="p_flag == 'Y'" />
  </div>
  <!-- content(e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
// import QuickMenu from '@/views/app/comm/QuickMenu';
import ApiService from '@/common/api.service';
import { convertPrice } from '@/common/common.filter';
import InfiniteLoading from 'vue-infinite-loading';
import JwtService from '@/common/jwt.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import UpdateWishList from '@/components/comm/UpdateWishList';

export default {
  name: 'productSalePrice',
  components: {
    // QuickMenu,
    InfiniteLoading,
    ConfirmPop,
    UpdateWishList,
  },
  data: function() {
    return {
      categoryList: null,
      bannerList: null,
      slideList: null,
      slideEvt: [],
      productList: [],
      productListLength: null,
      mainMenuIndex: 0,
      pageIdx: 1,
      maxPage: null,
      direction: 'DESC',
      filter: 'soldAmount',
      loadingState: [],
      p_flag: 'Y',
      selectedIdx: 0,

      token: JwtService.getToken(),

      msg: null,
      confirmPop: false,
    };
  },
  created() {
    // 카테고리 리스트 조회
    ApiService.service('GET', '/common/category')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.categoryList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 배너 이미지 조회
    ApiService.service('GET', '/resource/banner/31')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.bannerList = data.result[0].bannerDtos;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
  },
  async mounted() {
    // 추천 초특가 리스트 조회
    await ApiService.service('GET', '/product/recommend/specialprice')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.slideList = data.result;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    customjs.addStiky('.sortArea.filter');
    customjs.slideInit('#slide0', 0, false, 300, true, 'auto', 15);
  },
  methods: {
    searchSpecialprice(mainMenuIndex) {
      console.log(this.slideEvt);
      console.log(this.slideEvt.slides);
      // let se = this.slideEvt;
      // se.removeAllSlides();
      // se.update();
      ApiService.service('GET', '/product/recommend/specialprice/' + mainMenuIndex)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.slideList = data.result.content;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectCategory: function(mainMenuIndex, btnId) {
      this.mainMenuIndex = mainMenuIndex;
      this.pageIdx = 1;

      //this.searchSpecialprice(mainMenuIndex);
      this.searchProductList(this.pageIdx, '', mainMenuIndex);
      setTimeout(function() {
        customjs.slideInit('#slide' + mainMenuIndex, 0, false, 300, false, 'auto', 15);
      }, 300);
    },
    getConvertPrice: function(value) {
      return convertPrice(value);
    },
    searchProductList: function(page, filter, mainMenuIndex) {
      ApiService.service('GET', '/product/specialprice/' + mainMenuIndex, {
        params: { page: 1, size: 10, filter: this.filter, direction: this.direction },
      })
        .then(({ data }) => {
          if (data.isSucceed) {
            this.productList = data.result.content;
            this.productListLength = data.result.totalElements;
            this.maxPage = data.result.totalPages;
            this.p_flag = 'Y';
            this.loadingState.reset();
            this.pageIdx = 1;
            this.pageIdx++;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
      // .finally(() => {
      //   customjs.slideInit('#slide' + mainMenuIndex, 0, false, 300, false, 'auto', 15);
      // });
    },
    infiniteHandler: function($state) {
      //console.log('page:' + this.pageIdx); // page No
      this.loadingState = $state;
      if (this.maxPage < this.pageIdx && this.maxPage != null) {
        this.p_flag = 'N';
        return false;
      }

      ApiService.service('GET', '/product/specialprice/' + this.mainMenuIndex, {
        params: { page: this.pageIdx, size: 10, filter: this.filter, direction: this.direction },
      })
        .then(({ data }) => {
          if (data.isSucceed) {
            // this.productListLength = this.productListLength + data.result.content.length;
            this.productListLength = data.result.totalElements;

            for (let product of data.result.content) {
              this.productList.push(product);
            }
            this.maxPage = data.result.totalPages;
            this.pageIdx++;
            $state.loaded();
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    //소팅
    sort(key) {
      // 조건 여러개 사용시
      // this.categoryPrdList = this._.orderBy(this.categoryPrdList, ['rentalAmount', 'displayName'], ['desc', 'asc']);
      switch (key) {
        case 'highPrice': // 최고가순
          this.direction = 'DESC';
          this.filter = 'rentalAmount';
          break;
        case 'lowPrice': // 최저가순
          this.direction = 'ASC';
          this.filter = 'rentalAmount';
          break;
        case 'new': // 신상품순
          this.direction = 'DESC';
          this.filter = 'productIndex';
          break;
        default:
          this.direction = 'DESC';
          this.filter = 'soldAmount';
          break;
      }
      this.searchProductList(this.pageIdx, '', this.mainMenuIndex);
    },
    goProductDetail: function(productCode, discntFlag) {
      if (productCode != '0' && discntFlag != 'Y') {
        this.$router.push({ name: 'productDetail', params: { idx: productCode } });
      }
    },
    //찜관련
    updateWishList(product) {
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      console.log(product);
      console.log(flag);
      console.log(count);
      product.wishItem = flag;
      product.wishCount += count;
    },
    cancel: function() {
      this.confirmPop = false;
    },
    confirm: function() {
      this.$router.push({ name: 'login', params: { redirect: '/product/salePrice' } });
    },
  },
};
</script>
